import React, { Component } from 'react'
import { get, isEmpty, omit, pick } from 'lodash'
import ContractsApi from '../../../../../api/Purchase/PurchaseContracts'
import Suppliers from '../../../../../api/Purchase/Suppliers'
import Banks from '../../../../../api/Banks'
import Members from '../../../../../api/Members'
import { arrVal } from '../../../../../modules/Utils'
import { message } from 'antd'
import AddContract from '../../../../../components/Purchasing/Supplier/Contract/AddContract/AddContract'
import { withRouter } from 'react-router-dom'

class AddContractCont extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.contractKey = get(props.match, 'params.contractKey')
    this.state = {
      submitting: false,
      memberFetching: false,
      supplierFetching: false,
      showSkip: false,
      member: {},
      type: this.contractKey ? 'update' : 'new',
      supplier: {},
      contract: {},
      current: 0,
      selectedCompany: '',
    }
    this.contractApi = new ContractsApi()
    this.api = new Suppliers()
    this.memberApi = new Members()
    this.banksApi = new Banks()
  }

  async componentDidMount() {
    if (isEmpty(this.state.member)) {
      try {
        this.setState({
          memberFetching: true,
        })
        const supplierResponse = await this.api.get(this.key)
        let supplier = await supplierResponse.json()

        console.log({ supplier })
        const memberResponse = await this.memberApi.get((supplier.owner || '').replace('members/', ''))
        let member = await memberResponse.json()
        const contactsResponse = await this.memberApi.contacts.get(this.key)
        const contacts = await contactsResponse.json()
        let contract = {
          supplier: {
            address: arrVal(contacts, 'address').find((c) => c.default === true),
          },
        }
        if (this.contractKey) {
          contract = await this.contractApi.get(this.contractKey)
        }

        this.setState({
          member,
          supplier,
          contract,
          memberFetching: false,
          supplierFetching: false,
        })
      } catch (error) {
        message.error(error.errorMessage)
        this.setState({
          memberFetching: false,
          supplierFetching: false,
        })
      }
    }
  }

  overviewCmpRef = React.createRef()
  keyTermsCmpRef = React.createRef()
  payrollCmpRef = React.createRef()
  ratesCmpRef = React.createRef()
  linesCmpRef = React.createRef()
  communicationCmpRef = React.createRef()

  updateContract = (attribute, value) => {
    const contract = this.state.contract
    this.setState({
      contract: Object.assign({}, contract, { [attribute]: value }),
    })
  }
  prev = () => {
    const current = this.state.current - 1
    this.setState({ current, showSkip: false })
  }
  next = async () => {
    let valid = false
    this.setState({
      showSkip: true,
    })
    switch (this.state.current) {
      case 0:
        valid = await this.checkOverviewForm()
        break
      case 1:
        valid = await this.checkKeyTermsForm()
        break
      case 2:
        valid = await this.checkPaymentForm()
        break
      case 3:
        valid = await this.checkCommunicationForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current, showSkip: false })
    }
  }

  skip = () => {
    const current = this.state.current + 1
    this.setState({ current, showSkip: false })
  }

  submit = async () => {
    this.setState({ submitting: true })
    try {
      let contract = this.state.contract
      let lines = get(contract, 'lines') || []
      lines = lines.map((l) =>
        Object.assign({}, omit(l, 'key'), {
          contract: { _id: 'temp' },
        })
      )
      contract = omit(contract, ['_key', 'lines'])
      contract.supplier = Object.assign({}, contract.supplier, {
        _id: this.state.supplier._id,
      })
      await this.contractApi.createWithLines({ contract, lines })
      this.props.history.push({
        pathname: `/purchasing/suppliers/${this.key}/`,
        hash: 'contracts',
      })
    } catch (error) {
      message.error(error.errorMessage)
    }
    this.setState({ submitting: false })
  }

  update = async () => {
    let valid = true
    if (valid) {
      this.setState({ submitting: true })
      try {
        let contract = this.state.contract
        contract = omit(contract, ['code', 'revision', 'paid', 'invoiced', 'status', 'workOrders', '_history', 'owner'])
        contract.supplier = Object.assign({}, contract.supplier, {
          id: this.state.supplier._id,
        })

        await this.contractApi.update(contract)
        this.props.history.push({
          pathname: `/purchasing/suppliers/${this.key}/contracts/${contract._key}/view`,
        })
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
      }
      this.setState({ submitting: false })
    }
  }

  checkOverviewForm = () => {
    return new Promise((res, rej) => {
      this.overviewCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
          res(true)
        } else {
          const values = this.overviewCmpRef.current.getFieldsValue()
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
        }
      })
    })
  }
  checkKeyTermsForm = () => {
    return new Promise((res, rej) => {
      this.keyTermsCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
          res(true)
        } else {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
        }
      })
    })
  }
  checkPaymentForm = () => {
    return new Promise((res, rej) => {
      this.payrollCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState((prevState) => ({
            contract: { ...prevState.contract, ...values },
          }))
          res(true)
        }
      })
    })
  }
  checkCommunicationForm = () => {
    return new Promise((res, rej) => {
      this.communicationCmpRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
          res(true)
        } else {
          const values = this.communicationCmpRef.current.getFieldsValue()
          this.setState({
            contract: Object.assign({}, this.state.contract, values),
          })
        }
      })
    })
  }
  handleCancel = () => {
    this.setState({ visible: false })
    this.props.handleCancel()
  }

  onChangeCompany = (values) => {
    this.setState({ selectedCompany: false })
    this.setState({ selectedCompany: values })
  }

  onClickCompany = () => {
    this.setState({ selectedCompany: false })
  }

  render() {
    return (
      <AddContract
        {...this.state}
        {...pick(this, [
          'updateContract',
          'prev',
          'next',
          'skip',
          'submit',
          'update',
          'checkOverviewForm',
          'checkKeyTermsForm',
          'checkPaymentForm',
          'checkCommunicationForm',
          'handleCancel',
          'overviewCmpRef',
          'keyTermsCmpRef',
          'payrollCmpRef',
          'ratesCmpRef',
          'linesCmpRef',
          'communicationCmpRef',
        ])}
      />
    )
  }
}

AddContractCont.propTypes = {}
AddContractCont.defaultProps = {}

export default withRouter(AddContractCont)
